import api from "api/api";
export const deleteCountryCoefxById = async (id) =>
  await api.delete(`/settings/country/coefx/${id}`);

export const getCountryCoefxList = async (id) =>
  await api.get(`/settings/country/coefx/${id}`);

export const createCountryCoefx = async (data) =>
  await api.post("/settings/country/coefx", data);

export const updateCountryCoefxById = async (id, data) =>
  await api.put(`/settings/country/coefx/${id}`, data);
